import { createSlice } from "@reduxjs/toolkit";
import { Location } from "../models/Location/Location";

const LocationInitialState: {
	locations: Location[];
} = {
	locations: [],
};

export const LocationsReducer = createSlice({
	name: "__",
	initialState: LocationInitialState,
	reducers: {
		setLocations(state, { payload }) {
			state.locations = payload;
		},
	},
});
